import { Link } from "react-router-dom";
import { MapPin, Phone, Mail } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-drosun-navy text-white pt-16 pb-10" data-testid="site-footer">
      <div className="max-w-[1320px] mx-auto px-5 lg:px-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
        <div>
          <img src="/images/logo.png" alt="Drosun Italia" className="h-12 w-auto object-contain bg-white/95 rounded-md p-2 mb-5" width="160" height="48" />
          <p className="text-white/70 text-[15px] leading-relaxed">
            Drosun Italia: engineering, sviluppo stampi, produzione e assemblaggio industriale per componenti tecnici, prodotti completi e packaging B2B.
          </p>
        </div>

        <div>
          <h4 className="font-display uppercase text-lg tracking-wide mb-5">Link rapidi</h4>
          <ul className="space-y-3 text-white/80 text-[15px]">
            <li><Link to="/" className="hover:text-drosun-red transition-colors">Home</Link></li>
            <li><Link to="/servizi" className="hover:text-drosun-red transition-colors">Servizi</Link></li>
            <li><Link to="/prodotti/componenti-arredamento" className="hover:text-drosun-red transition-colors">Arredamento</Link></li>
            <li><Link to="/prodotti/componenti-nautica" className="hover:text-drosun-red transition-colors">Nautica</Link></li>
            <li><Link to="/prodotti/packaging-cosmetico" className="hover:text-drosun-red transition-colors">Beauty</Link></li>
            <li><Link to="/prodotti/food-packaging-pet" className="hover:text-drosun-red transition-colors">Packaging</Link></li>
            <li><Link to="/contatti" className="hover:text-drosun-red transition-colors">Contatti</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-display uppercase text-lg tracking-wide mb-5">Servizi</h4>
          <ul className="space-y-3 text-white/80 text-[15px]">
            <li>Engineering & OEM/ODM</li>
            <li>Sviluppo & produzione stampi</li>
            <li>Stampaggio ad iniezione</li>
            <li>Lavorazioni CNC</li>
            <li>Assemblaggio & logistica</li>
          </ul>
        </div>

        <div>
          <h4 className="font-display uppercase text-lg tracking-wide mb-5">Contatti</h4>
          <ul className="space-y-4 text-white/80 text-[15px]">
            <li className="flex items-start gap-3">
              <MapPin size={18} className="mt-0.5 text-drosun-red shrink-0" />
              <span>Drosun<br/>Building 6, TuoFu SongShanHu Technical Park,<br/>No.2 Xinghui Road, Dongguan City,<br/>Guandong Province, China, 523451</span>
            </li>
            <li className="flex items-start gap-3">
              <Phone size={18} className="mt-0.5 text-drosun-red shrink-0" />
              <span><strong className="text-white">Europe manager office</strong><br/><a href="tel:+393939881139" className="hover:text-white">+39 3939881139</a></span>
            </li>
            <li className="flex items-start gap-3">
              <Mail size={18} className="mt-0.5 text-drosun-red shrink-0" />
              <a href="mailto:Europe@drosun-eu.com" className="hover:text-white break-all">Europe@drosun-eu.com</a>
            </li>
            <li className="flex items-start gap-3">
              <Phone size={18} className="mt-0.5 text-drosun-red shrink-0" />
              <span><strong className="text-white">Sales office</strong><br/><a href="tel:+393514642407" className="hover:text-white">+39 3514642407</a></span>
            </li>
            <li className="flex items-start gap-3">
              <Mail size={18} className="mt-0.5 text-drosun-red shrink-0" />
              <a href="mailto:Sales@drosun-eu.com" className="hover:text-white break-all">Sales@drosun-eu.com</a>
            </li>
          </ul>
        </div>
      </div>
      <div className="max-w-[1320px] mx-auto px-5 lg:px-10 mt-12 pt-8 border-t border-white/10 flex flex-col sm:flex-row gap-4 justify-between text-sm text-white/55">
        <span>© {new Date().getFullYear()} Drosun Italia. Tutti i diritti riservati.</span>
        <span className="flex gap-5"><Link to="/privacy" className="hover:text-white">Privacy Policy</Link><Link to="/cookie" className="hover:text-white">Cookie Policy</Link></span>
      </div>
    </footer>
  );
}
